import type { MfgMaterialIssuanceSummary } from "@/lib/manufacturing/materialIssuanceClient";

const usd = (n: number) =>
  "$" + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function ManufacturingInventoryMaterialDrawerHistory({
  unit,
  ledger,
  issuances,
}: {
  unit: string;
  ledger: Array<{ id: string; entry_type: string; quantity: number; unit_cost: number; notes: string }>;
  issuances: MfgMaterialIssuanceSummary[];
}) {
  return (
    <>
      <section>
        <h3 className="mb-1 text-xs font-semibold uppercase text-gray-500">Cost ledger</h3>
        <ul className="space-y-1 text-xs">
          {ledger.length === 0 ? (
            <li className="text-gray-500">No entries.</li>
          ) : (
            ledger.map((e) => (
              <li
                key={e.id}
                className="flex justify-between gap-2 border-b border-gray-100 py-1 dark:border-zinc-800"
              >
                <span className="uppercase text-gray-500">{e.entry_type}</span>
                <span className="font-mono">
                  {e.notes.startsWith("On-hand price")
                    ? e.notes.split(". ")[0]
                    : `${e.quantity >= 0 ? "+" : ""}${e.quantity} @ ${usd(e.unit_cost)}`}
                </span>
              </li>
            ))
          )}
        </ul>
      </section>

      <section>
        <h3 className="mb-1 text-xs font-semibold uppercase text-gray-500">Issued to builds</h3>
        <ul className="space-y-1 text-xs">
          {issuances.length === 0 ? (
            <li className="text-gray-500">No issuances.</li>
          ) : (
            issuances.slice(0, 10).map((ev) => (
              <li key={ev.id} className="flex justify-between gap-2">
                <span className="font-mono text-gray-500">{ev.mfg_unit_id?.slice(0, 8) || "—"}</span>
                <span className="font-mono">
                  {ev.quantity} {unit}
                </span>
              </li>
            ))
          )}
        </ul>
      </section>
    </>
  );
}
